import { workerRegistry } from "@/lib/agents/registry"
import { NodeProps } from '@xyflow/react'
import { UserCheck } from "lucide-react"
import { InlineHandles, WorkerLabeledHandle } from "../handles"
import { useWorker } from "../hooks"
import { NodeLayout } from './node'
import { app } from "@/lib/app"

const { hitl } = workerRegistry

hitl.icon = UserCheck

export function HITLNode(props: NodeProps) {
  const worker = useWorker<HITLWorker>(props.id)
  const active = worker.fields.enabled.value

  return <NodeLayout worker={worker}>
    <InlineHandles>
      <WorkerLabeledHandle handler={worker.fields.enable} />
      <WorkerLabeledHandle handler={worker.fields.enabled} />
    </InlineHandles>
    <WorkerLabeledHandle handler={worker.fields.causes} />
    <h1 className="text-2xl text-center font-medium mt-8">Human In The Loop</h1>
    {!active && <h1 className="text-2xl text-center font-medium my-4 text-gray-500">Deactivated</h1>}
    {active && <h1 className="text-2xl text-center font-medium my-4 text-red-500">Activated</h1>}
  </NodeLayout>
}
